import { createBrowserRouter, Navigate, RouterProvider, useParams, useSearchParams } from 'react-router-dom';
import { Shell } from './components/Shell';
import { AppDataProvider, ScopedDataProvider, useAppData } from './state/AppData';
import { SelectionProvider } from './state/selection';
import { ExploreView } from './routes/ExploreView';
import { ActivityList, ActivityView } from './routes/Activities';
import { Classroom } from './routes/Classroom';
import { Home } from './routes/Home';
import { Landing } from './routes/Landing';
import { Legal } from './routes/Legal';
import { ItineraryList, ItineraryView } from './routes/Itineraries';
import { Placeholder } from './routes/Placeholder';
import { ReadView } from './routes/ReadView';
import { Search } from './routes/Search';
import { Sources } from './routes/Sources';
import { Volume } from './routes/Volume';

function Root() {
  return (
    <ScopedDataProvider>
      <SelectionProvider>
        <Shell />
      </SelectionProvider>
    </ScopedDataProvider>
  );
}

/** La portada del proyecto va fuera del ámbito de ciudad: habla de las seis colecciones y no debe
 *  esperar a que se descargue ninguna. Por eso no cuelga de Root ni lleva la cabecera de la app. */

function PlaceBySlug() {
  const { slug } = useParams();
  const { places } = useAppData();
  const p = places.find((x) => x.properties.slug === slug);
  return <Navigate to={p ? `/explorar?place=${p.id}` : '/explorar'} replace />;
}

function ReadRedirect() {
  const [params] = useSearchParams();
  const { index } = useAppData();
  const para = params.get('paragraph');
  const chapter = para?.match(/^[a-z]{3}-c\d{2}/)?.[0] ?? index.chapters[0]?.chapterId;
  return <Navigate to={`/leer/${chapter}?${params}`} replace />;
}

// Direcciones reales, sin almohadilla: cada sección, cada capítulo y cada lugar tienen su propia
// dirección, que un buscador puede indexar y alguien puede compartir (ADR-0016). El alojamiento
// reescribe a index.html lo que no sea un archivo, con las reglas de app/public/.htaccess.
const router = createBrowserRouter([
  { path: '/', element: <Landing /> },
  {
    element: <Root />,
    children: [
      { path: '/ciudad', element: <Home /> },
      { path: '/leer', element: <ReadRedirect /> },
      { path: '/leer/:chapterId', element: <ReadView /> },
      { path: '/explorar', element: <ExploreView /> },
      { path: '/lugares/:slug', element: <PlaceBySlug /> },
      { path: '/itinerarios', element: <ItineraryList /> },
      { path: '/itinerarios/:slug', element: <ItineraryView /> },
      { path: '/retos', element: <ActivityList /> },
      { path: '/retos/:slug', element: <ActivityView /> },
      { path: '/buscar', element: <Search /> },
      { path: '/aula', element: <Classroom /> },
      { path: '/aula/:slug', element: <Classroom /> },
      { path: '/volumen', element: <Volume /> },
      { path: '/proyecto/fuentes', element: <Sources /> },
      { path: '/proyecto/aviso-legal', element: <Legal /> },
      { path: '*', element: <Placeholder title="Página no encontrada"><p>Esta dirección no existe en la edición.</p></Placeholder> },
    ],
  },
]);

export function App() {
  return (
    <AppDataProvider>
      <RouterProvider router={router} />
    </AppDataProvider>
  );
}
